import script from "./EditEmailTemplatesBox.vue?vue&type=script&setup=true&lang=js"
export * from "./EditEmailTemplatesBox.vue?vue&type=script&setup=true&lang=js"

import "./EditEmailTemplatesBox.vue?vue&type=style&index=0&id=26b819ae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26b819ae"]])

export default __exports__